import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Store } from 'redux'
import { combineReducers, createStore } from '@reduxjs/toolkit'
import reportWebVitals from './reportWebVitals'

import './index.scss'
import App from './pages/app/App'
import * as serviceWorker from './serviceWorker'
import { formReducer, IWithForms } from 'formBuilder/src'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import appConfig from 'app.config'
import ExternalServices from 'services/externalServices'

if (appConfig.cookiebotId)
	ExternalServices.initializeCookiebot(appConfig.cookiebotId)

if (appConfig.gtmId)
	ExternalServices.initializeGoogleTagManger(appConfig.gtmId)

const rootReducer = combineReducers({
	forms: formReducer,
})

const store: Store<IWithForms> = createStore(rootReducer)

ReactDOM.render(
	<Provider store={store}>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</Provider>,
	document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
